export type PlanStepIndexInput = {
  status: string;
};

export type PlanWithStepIndex = {
  steps: PlanStepIndexInput[];
  currentStepIndex?: number;
};

/**
 * Index of the step plan execution/UI should treat as current: in_progress, else first pending,
 * else clamp stored currentStepIndex. When currentStepIndex still points at a completed step,
 * resume can appear stuck until the cursor is re-homed.
 */
export function resolvePlanStepIndex(plan: PlanWithStepIndex): number {
  const inProgressIndex = plan.steps.findIndex((s) => s.status === "in_progress");
  if (inProgressIndex >= 0) return inProgressIndex;

  const pendingIndex = plan.steps.findIndex((s) => s.status === "pending");
  if (pendingIndex >= 0) return pendingIndex;

  const maxIndex = Math.max(plan.steps.length - 1, 0);
  const stored = typeof plan.currentStepIndex === "number" ? plan.currentStepIndex : 0;
  return Math.min(Math.max(0, Math.floor(stored)), maxIndex);
}
